module.exports = __webpack_public_path__ + "static/csio-homepage-c59950de62c0d14738f144488f24c11d.png";